import Axios from 'axios'
import React, { Component } from 'react'
import './Forum.scss'
import { Link } from 'react-router-dom'
import shortid from 'shortid'
import Topbar from '../../Common/Topbar'
import RoundCard from '../../Components/RoundCard'
import Spinner from '../../Components/Spinner'
import config from '../../Shared/config'
import { calculateTimeDifference } from '../../Utils/Datetime'
import { ReactComponent as DeleteIcon } from '../../Shared/icons/delete.svg'
import EquationControl from '../../Components/EquationControl'
import Button from '../../Components/Button'
import Token from '../../Utils/Token'
export default class Forum extends Component {

    refreshFeeds = () => {
        this.feeds.fetchFeeds()
    }

    render() {
        return (
            <div className='forum'>
                <Topbar type={'fixedover'} theme={'solid'} />
                <div className="forum-content">
                    <AddNewPost refreshFeeds={this.refreshFeeds} />
                    <div className="quickfacts">
                        <TopContributers />
                        <TrendingQuestions />
                    </div>
                    <Feeds ref={e => this.feeds = e} />
                </div>
            </div>
        )
    }
}

class AddNewPost extends Component {
    constructor(props) {
        super(props)

        this.state = {
            questionForm: {
                title: '',
                description: '',
                descriptionElements: []
            },
        }
    }

    onChangeQuestionForm = (e) => {
        let { questionForm } = this.state
        questionForm[e.target.id] = e.target.value;
        this.setState({
            questionForm
        })
    }

    onInput = (e) => {
        let { questionForm } = this.state
        let obj = questionForm.descriptionElements.find(x => x.name === e.currentTarget.id)
        obj.value = e.currentTarget.textContent
        this.setState({ questionForm })
    }

    onInputEquation = (e, ref) => {
        let { questionForm } = this.state
        let obj = questionForm.descriptionElements.find(x => x.name === e.currentTarget.id)
        obj.value = e.currentTarget.textContent
        this.setState({ questionForm })
        ref.setState({
            editable: false
        })
    }

    addElement = (type) => {
        let { questionForm } = this.state;
        questionForm.descriptionElements.push({
            type: type,
            name: `element_${shortid.generate()}`,
            value: ''
        })
        this.setState({ questionForm: questionForm })
    }

    deleteElement = (name) => {
        let { questionForm } = this.state;
        questionForm.descriptionElements = questionForm.descriptionElements.filter(x => x.name !== name)
        this.setState({ questionForm: questionForm })
    }

    postQuestion = () => {
        const url = `${config.apiUrl}/Post/addpost`
        let data = this.state.questionForm;
        Axios.post(url, data).then(res => {
            alert(res.data.message)
            if (!res.data.error) {
                this.clearQuestionForm()
                this.props.refreshFeeds()
            } else {

            }
        }).catch(err => {

        })
    }

    clearQuestionForm = () => {
        this.setState({
            questionForm: {
                title: '',
                description: '',
                descriptionElements: []
            }
        })
    }

    render() {
        let token = Token.getToken();

        return (
            <RoundCard scaleOnHover={false} className='addnewpost'>
                <h2>Ask something <img src='https://image.flaticon.com/icons/svg/788/788893.svg' alt='ask'></img></h2>

                <div className="postform">
                    <div className='label'>Title</div>
                    <input
                        onChange={this.onChangeQuestionForm}
                        value={this.state.questionForm['title'] || ''}
                        id='title'
                        type='text'
                        className="field input-field-main"
                    />

                    <div className='label'>Description</div>
                    <div className='description-container input-field-main field'>
                        <div className='editor-options'>
                            <button className='editor-btn' onClick={() => { this.addElement('text') }}>T</button>
                            <button className='editor-btn' onClick={() => { this.addElement('equation') }}>Eq</button>
                        </div>

                        <div className='editor-main'>
                            {
                                this.state.questionForm.descriptionElements.map((item, idx) => {
                                    switch (item.type.toLowerCase()) {
                                        case 'text':
                                            return (
                                                <div className="editor-field">
                                                    <div onBlur={this.onInput} id={item.name} className='editor-contenteditable' contentEditable='true'>
                                                        {item.value}
                                                    </div>
                                                    <div className="editor-field-options">
                                                        <DeleteIcon onClick={e => { this.deleteElement(item.name) }} className='icon' />
                                                    </div>
                                                </div>
                                            )
                                        case 'equation':
                                            return (
                                                <div className="editor-field">
                                                    <EquationControl onInput={this.onInputEquation} item={item} />
                                                    <div className="editor-field-options">
                                                        <DeleteIcon onClick={e => { this.deleteElement(item.name) }} className='icon' />
                                                    </div>
                                                </div>
                                            )
                                        default: return null
                                    }
                                })
                            }
                        </div>
                    </div>
                    <div className="postoptions">
                        <Button onClick={token ? this.postQuestion : () => { }} className='save-btn' variant='primary'>Save</Button>
                        <Button onClick={this.clearQuestionForm} className='reset-btn' variant='primary'>Reset</Button>
                    </div>
                </div>
            </RoundCard>
        )
    }
}

class TopContributers extends Component {
    constructor(props) {
        super(props)

        this.state = {
            topContributers: [],
            topContributersFetching: true,
            topContributersFetched: false,
        }
    }

    componentDidMount() {
        this.fetchTopContributers()
    }

    fetchTopContributers = () => {
        this.setState({
            topContributersFetching: true
        })
        const url = `${config.apiUrl}/Post/gettopcontributers`;
        Axios.get(url).then(res => {
            if (!res.data.error) {
                this.setState({
                    topContributers: res.data.data,
                    topContributersFetching: false,
                    topContributersFetched: true
                })
            } else {
                this.setState({
                    topContributers: [],
                    topContributersFetching: false,
                    topContributersFetched: false
                })
            }
        }).catch(err => {
            this.setState({
                topContributers: [],
                topContributersFetching: false,
                topContributersFetched: false
            })
        })
    }

    randomImages = [
        'https://image.flaticon.com/icons/svg/145/145867.svg',
        'https://image.flaticon.com/icons/svg/145/145859.svg',
        'https://image.flaticon.com/icons/svg/145/145852.svg',
        'https://image.flaticon.com/icons/svg/2922/2922506.svg',
        'https://image.flaticon.com/icons/svg/3048/3048122.svg'
    ]

    render() {
        const { topContributers, topContributersFetched, topContributersFetching } = this.state

        return (
            <RoundCard scaleOnHover={false} className='topcontributers'>
                <h2>Top Contributers <img alt='crown' src='https://image.flaticon.com/icons/svg/3163/3163798.svg'></img></h2>
                <div className="contributers">
                    {
                        topContributersFetching ? (
                            <Spinner />
                        ) : (
                                topContributersFetched ? (
                                    topContributers.map((item, idx) => {
                                        return (
                                            <div className='contributer'>
                                                <img alt='user' src={this.randomImages[Math.floor(Math.random() * this.randomImages.length)]}></img>
                                                <div className='name'>{`${item.firstName} ${item.lastName}`}</div>
                                                <div className='score'>{item.contributions || 0}</div>
                                            </div>
                                        )
                                    })
                                ) : null
                            )
                    }
                </div>
            </RoundCard>
        )
    }
}

class TrendingQuestions extends Component {
    constructor(props) {
        super(props)

        this.state = {
            trendingQuestions: [],
            trendingQuestionsFetching: true,
            trendingQuestionsFetched: false,
        }
    }

    componentDidMount() {
        this.fetchTrendingQuestions()
    }

    fetchTrendingQuestions = () => {
        this.setState({
            trendingQuestionsFetching: true
        })
        const url = `${config.apiUrl}/Post/gettrendingquestions`;
        Axios.get(url).then(res => {
            if (!res.data.error) {
                this.setState({
                    trendingQuestions: res.data.data,
                    trendingQuestionsFetching: false,
                    trendingQuestionsFetched: true
                })
            } else {
                this.setState({
                    trendingQuestions: [],
                    trendingQuestionsFetching: false,
                    trendingQuestionsFetched: false
                })
            }
        }).catch(err => {
            this.setState({
                trendingQuestions: [],
                trendingQuestionsFetching: false,
                trendingQuestionsFetched: false
            })
        })
    }

    render() {

        const { trendingQuestionsFetching, trendingQuestionsFetched, trendingQuestions } = this.state

        return (
            <RoundCard scaleOnHover={false} className='trendingquestions'>
                <h2>Trending Questions <img alt='fire' src='https://image.flaticon.com/icons/svg/3094/3094653.svg'></img></h2>
                <div className="questions">
                    {
                        trendingQuestionsFetching ? (
                            <Spinner />
                        ) : (
                                trendingQuestionsFetched ? (
                                    trendingQuestions.map((item, idx) => {
                                        return (
                                            <div className='trending-question-single'>
                                                <Link className="question-link" to={`/post/${item._id}`} key={idx}>
                                                    <div className='trending-question'>{item.title || ''}</div>
                                                    <div className='trending-meta'>
                                                        <div className='like-count'> <img src={require('../../Shared/icons/like.svg')} alt='views-icon'></img>{item.likeCount}</div>
                                                        <div className='comment-count'> <img src={require('../../Shared/icons/comment.svg')} alt='views-icon'></img>{item.commentCount}</div>
                                                    </div>
                                                </Link>
                                            </div>
                                        )
                                    })
                                ) : null
                            )
                    }
                </div>
            </RoundCard>
        )
    }
}

class Feeds extends Component {
    constructor(props) {
        super(props)

        this.state = {
            feeds: [],
            feedsFetching: true,
            feedsFetched: false,
        }
    }

    componentDidMount() {
        this.fetchFeeds()
    }

    fetchFeeds = () => {
        this.setState({
            feedsFetching: true
        })
        const url = `${config.apiUrl}/Post/getallposts`;
        Axios.get(url).then(res => {
            if (!res.data.error) {
                this.setState({
                    feeds: res.data.data,
                    feedsFetching: false,
                    feedsFetched: true
                })
            } else {
                this.setState({
                    feeds: [],
                    feedsFetching: false,
                    feedsFetched: false
                })
            }
        }).catch(err => {
            this.setState({
                feeds: [],
                feedsFetching: false,
                feedsFetched: false
            })
        })
    }

    render() {

        const { feeds, feedsFetched, feedsFetching } = this.state

        return (
            <RoundCard scaleOnHover={false} className='feeds'>
                <h2>Here are a few questions that you might be interested in</h2>

                <div className="allfeeds">
                    {
                        feedsFetching ? (
                            <Spinner />
                        ) : (
                                feedsFetched ? (
                                    <>
                                        {
                                            feeds.map((item, index) => {
                                                return (
                                                    <Link className="question-link" to={`/post/${item._id}`} key={index}>
                                                        <FeedItem item={item} />
                                                    </Link>
                                                )
                                            })
                                        }
                                    </>
                                ) : null
                            )
                    }
                </div>
            </RoundCard>
        )
    }
}

class FeedItem extends Component {
    render() {
        const { item } = this.props;

        return (
            <div className='feeditem'>
                <div className='title'>{item.title}</div>

                <div className='question-meta-container'>
                    <div className='asker'>by <span>{`${item.posterInfo ? item.posterInfo.firstName || '' : ''} ${item.posterInfo ? item.posterInfo.lastName || '' : ''}`}</span></div>
                    <div className='time'>{calculateTimeDifference(item.postDate)}</div>
                    <div className='comment-count'>{item.commentCount} comments</div>
                </div>

                <div className='other-info-container'>
                    <div className='categories'>
                        {
                            item.categories.map((cat, idx) => {
                                return (
                                    <div className={`category ${cat.cssClass}`}>{cat.name}</div>
                                )
                            })
                        }
                    </div>

                    <div className='stats'>
                        <div className='stat-single'>
                            <img src={require('../../Shared/icons/view.svg')} alt='views-icon'></img>
                            <span>{item.viewCount}</span>
                        </div>
                        <div className='stat-single'>
                            <img src={require('../../Shared/icons/like.svg')} alt='views-icon'></img>
                            <span>{item.likeCount}</span>
                        </div>
                        <div className='stat-single'>
                            <img src={require('../../Shared/icons/comment.svg')} alt='views-icon'></img>
                            <span>{item.commentCount}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}